import React from 'react';
import { BAND_CLS, BAND_LABEL, type ReadinessBand } from '../../lib/vessel/readiness';

interface Props {
  score: number;
  band: ReadinessBand;
  className?: string;
}

/**
 * Minimal readiness pill for list rows and map popups — renders straight from
 * the persisted server score/band (no VesselProfile required).
 */
export default function ReadinessPill({ score, band, className }: Props) {
  const cls = BAND_CLS[band];
  return (
    <span
      title={`Readiness ${score} / 100 — ${BAND_LABEL[band]}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[11px] font-bold tabular-nums ${cls.bg} ${cls.ring} ${cls.text} ${className ?? ''}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${cls.dot}`} />
      <span>{score}</span>
      <span className="opacity-80">·</span>
      <span className="uppercase tracking-wider text-[10px]">{BAND_LABEL[band]}</span>
    </span>
  );
}
